import React, { useState, useRef } from 'react';
import dayjs from 'dayjs';

import { Fields, Modes } from '@C/Banking/';
import { ToggleSwitch } from '@C/FormElements';
import ReturnList from '@C/Loans/RouteComponents/Lend/ReturnList';
import { DateFilter, StaffList, LoanPartyList } from '@C/Utils';
import SimpleReactValidator from 'simple-react-validator';

const Lend = () => {
  const [state, setState] = useState({
    time_stamp: dayjs().format('YYYY-MM-DD'),
    notes: '',
    given_by: '',
    party_name: '',
    outstanding: '',
    staff_id: '',
    amount: '',
    interest: 0,
    is_partial: false,
    payment: {
      bank_id: null,
      payment_method: 'OFFLINE',
      source: 'CASH',
      check_date: '',
      check_number: '',
      mode: 'cash',
    },
    editMode: false,
    updated: false,
    isSubmitting: false,
  });

  const [_, forceUpdate] = useState();
  const paymentFieldsRef = useRef(null);
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } }),
  );

  const cancelEdit = () => {
    setState({
      time_stamp: dayjs().format('YYYY-MM-DD'),
      given_by: '',
      party_name: '',
      return_by: '',
      outstanding: '',
      is_partial: false,
      amount: '',
      interest: 0,
      notes: '',
      payment: {
        bank_id: null,
        payment_method: 'OFFLINE',
        source: 'CASH',
        check_date: '',
        check_number: '',
        mode: 'cash',
      },
      updated: false,
      editMode: false,
      isSubmitting: false,
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    const isMainFormValid = validator.current.allValid();
    const isPaymentFieldsValid =
      !paymentFieldsRef.current || !paymentFieldsRef.current.validateFields
        ? true
        : paymentFieldsRef.current.validateFields();

    if (!isMainFormValid || !isPaymentFieldsValid) {
      validator.current.showMessages();
      forceUpdate(Math.random());
      return;
    }
  };

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const handleStaffChange = (selectedStaff) => {
    setState({
      ...state,
      staff_id: selectedStaff,
    });
  };

  const handlePaymentSelect = (selectedMode) => {
    setState({
      ...state,
      payment: {
        ...state.payment,
        mode: selectedMode,
      },
    });
  };

  const onDataChange = (data) => {
    setState({
      ...state,
      payment: {
        ...state.payment,
        ...data,
      },
    });
  };

  const handleLoanPartyChange = (selectedParty) => {
    setState({
      ...state,
      party_name: selectedParty.value || '',
      outstanding: selectedParty?.outstanding || '',
    });
  };

  return (
    <>
      <section className="widget full-width">
        <header>
          <h3> Give amount </h3>
        </header>
        <main>
          <form className="inline">
            <div className="input-wrapper with-label ">
              <label> Date</label>
              {validator.current.message('date', state.time_stamp, 'required')}
              <DateFilter
                name="time_stamp"
                onChange={handleChange}
                value={state.time_stamp}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Select party </label>
              {validator.current.message(
                'party_name',
                state.party_name,
                'required',
              )}
              <LoanPartyList
                value={state.party_name}
                onChange={handleLoanPartyChange}
                name="party_name"
                disabled={state.editMode}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Current outstanding </label>
              <input
                type="text"
                onChange={handleChange}
                value={state.outstanding}
                name="given_by"
                disabled
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Select staff:</label>
              {validator.current.message(
                'staff_id',
                state.staff_id,
                'required',
              )}
              <StaffList
                value={state.staff_id}
                onChange={handleStaffChange}
                staffType={['Cashiers', 'Managers', 'Dealer']}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Principal amount </label>
              {validator.current.message('amount', state.amount, 'required')}
              <input
                type="text"
                value={state.amount}
                name="amount"
                onChange={handleChange}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Interest </label>
              <input
                type="text"
                value={state.interest}
                name="interest"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <div className="input-wrapper with-label">
                <label>Payment mode</label>
                <Modes
                  handleModeChange={handlePaymentSelect}
                  value={state.payment.mode || 'cash'}
                  disabled={state.editMode}
                />
              </div>
              <Fields
                ref={paymentFieldsRef}
                method={state.payment.mode}
                onDataChange={onDataChange}
                bank={state.payment.bank}
                bank_reference_id={state.payment.bank_reference_id}
                check_date={state.payment.check_date}
                disabled={state.editMode}
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Amount given </label>
              <input
                type="text"
                value={parseFloat(+state.interest + +state.amount)}
                name="return_by"
                disabled
              />
            </div>
            <div className="input-wrapper with-label ">
              <label> Notes </label>
              <input
                type="text"
                value={state.notes}
                name="notes"
                onChange={handleChange}
              />
            </div>
            <div className="form-actions">
              <button className="submit" onClick={submitForm}>
                Submit
              </button>
              {state.editMode && (
                <button
                  className="red-btn"
                  disabled={state.isSubmitting}
                  onClick={cancelEdit}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </main>
      </section>
      <ReturnList onEdit={state.editMode} key={state.updated} />
    </>
  );
};

export { Lend };
